var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeuro1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16.917583 20.512819",
    id: "svg18",
    width: 17,
    height: 20.512819,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style1"
  }, "\n      .neuro-1-cls-1 {\n        stroke-dasharray: .52 2.58;\n      }\n\n      .neuro-1-cls-1, .neuro-1-cls-2, .neuro-1-cls-3, .neuro-1-cls-4 {\n        stroke-width: 1.5px;\n      }\n\n      .neuro-1-cls-1, .neuro-1-cls-2, .neuro-1-cls-3, .neuro-1-cls-4, .neuro-1-cls-5 {\n        fill: none;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .neuro-1-cls-1, .neuro-1-cls-4 {\n        stroke: #000;\n      }\n\n      .neuro-1-cls-6 {\n        fill: #231f20;\n      }\n\n      .neuro-1-cls-2 {\n        stroke-dasharray: 1 3.5;\n      }\n\n      .neuro-1-cls-2, .neuro-1-cls-3, .neuro-1-cls-5 {\n        stroke: #231f20;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g18",
    transform: "translate(-6.1624174,-3.6371806)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "neuro-1-cls-4",
    d: "M 6.94,22.9 C 6.9,22.46 6.91,22.11 6.93,21.88 7.02,20.48 7.6,18.76 7.6,18.08 7.6,17.64 7.54,17.32 7.5,17.14 7.2,15.51 6.99,14.4 7.18,13.34 7.22,13.08 7.5,11.49 8.73,10.73 c 0.46,-0.28 0.94,-0.38 1.35,-0.47 0.4,-0.08 1.65,-0.3 2.36,-0.45 0.14,-0.03 0.44,-0.11 0.55,-0.34 0.04,-0.08 0.04,-0.16 0.03,-0.21 0,-0.25 -0.16,-0.44 -0.19,-0.48 -0.24,-0.31 -0.67,-1.93 0.02,-3.1 0.47,-0.79 1.28,-1.11 1.68,-1.23 0.24,-0.07 0.52,-0.06 0.52,-0.06 0.21,0 0.38,0 0.52,0.02 0.32,0.08 1.14,0.33 1.65,1.1 0,0 0.61,0.92 0.32,2.52 -0.04,0.21 -0.1,0.39 -0.1,0.39 -0.04,0.13 -0.14,0.41 -0.34,0.73 -0.27,0.43 -0.41,0.42 -0.03,0.84 0.63,0.69 1.47,1.23 2.23,1.78 0.71,0.51 1.42,1.04 1.78,1.84 0.35,0.8 0.11,1.57 0.2,2.4 0.09,0.83 0.14,1.04 0.42,2.72 0.2,1.18 0.09,1.49 0.33,2.82 0.02,0.12 0.04,0.22 0.09,0.45 0.05,0.25 0.12,0.61 0.21,1.04",
    id: "path1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "neuro-1-cls-4",
    d: "m 18.34,14.89 c -0.04,0.22 -0.11,0.51 -0.19,0.84 -0.12,0.47 -0.2,0.8 -0.35,1.21 -0.27,0.75 -0.43,0.86 -0.47,1.36 -0.03,0.31 0,0.55 0.03,0.65 0.08,0.43 0.26,0.73 0.32,0.83 0.23,0.39 0.65,1.33 1.49,3.43",
    id: "path2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "neuro-1-cls-4",
    d: "M 9.58,13.54",
    id: "path3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "neuro-1-cls-4",
    d: "M 11.16,23.4 C 11.07,21.9 11.37,20.39 10.94,18.92 10.44,17.21 10.32,15.44 9.95,13.7",
    id: "path4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "neuro-1-cls-4",
    d: "m 9.82,23.05 c 0.6,-1.58 0.7,-3.15 0.95,-4.77",
    id: "path5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "neuro-1-cls-4",
    d: "m 19.16,23.22 c -0.64,-1.61 -0.81,-2.77 -0.83,-3.55 0,-0.2 -0.01,-0.58 -0.06,-1.14 -0.07,-0.91 -0.2,-1.65 -0.31,-2.13",
    id: "path6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "neuro-1-cls-4",
    d: "M 14.71,23.4 C 14.68,23.33 14.65,23.26 14.62,23.17",
    id: "path7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "neuro-1-cls-1",
    d: "m 14.2,20.64 c 0,-0.19 -0.01,-0.4 -0.02,-0.64 -0.06,-1.6 -0.13,-1.41 -0.08,-1.68 0.19,-1.08 0.78,-1.14 1.17,-2.42 0.11,-0.37 0.31,-1.02 0.19,-1.82 -0.12,-0.81 -0.42,-0.91 -0.58,-1.82 -0.07,-0.39 -0.05,-0.85 0,-1.74 0.07,-1.37 0.13,-1.19 0.17,-2.15 0.02,-0.59 0.01,-1.05 0.05,-1.49",
    id: "path8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "neuro-1-cls-4",
    d: "M 15.37,5.62 C 15.4,5.52 15.44,5.44 15.46,5.39",
    id: "path9"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeuro1);
export default __webpack_public_path__ + "static/media/Neuro-1.00ae438df4bf299b3fe848b1c37a9f89.svg";
export { ForwardRef as ReactComponent };